import src from "IMAGE";
export default { src, width: 321, height: 169, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASklEQVR42oXNsQ6AIAxFURakoUVsI6lxUcH+/y/awZ2XnOkNN4TZYspMrKPupxU5rLAabe1yd4JMIQIK1tb9eN34PatojwvgtPABNS4ErkRfYe4AAAAASUVORK5CYII="};
